//checkbox
global.modules.set({
  async init(context) {
    $('.checkbox__element', context).each(function() {
      var elem = $(this);
      elem.on('click', function() {
        var checkbox = elem.find('[type="checkbox"]');
        if(checkbox.attr('checked')) {
          elem.removeClass('active')
          checkbox.removeAttr('checked')
        } else {
          elem.addClass('active')
          checkbox.attr('checked', 'checked')
        }
        $(checkbox).trigger('change').trigger('focus').trigger('keyup')
      })
    })
  }
})